import { z } from 'zod';

// Brazilian phone regex - accepts formats like (XX) XXXXX-XXXX or XXXXXXXXXXX
const brazilianPhoneRegex = /^(\(?\d{2}\)?\s?)?\d{4,5}-?\d{4}$/;

export const contactDialogSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, { message: "Nome deve ter pelo menos 2 caracteres" })
    .max(100, { message: "Nome deve ter no máximo 100 caracteres" }),
  email: z
    .string()
    .trim()
    .email({ message: "Email inválido" })
    .max(255, { message: "Email deve ter no máximo 255 caracteres" }),
  message: z
    .string()
    .trim()
    .min(10, { message: "Mensagem deve ter pelo menos 10 caracteres" })
    .max(2000, { message: "Mensagem deve ter no máximo 2000 caracteres" }),
});

export const cadastroSchema = z.object({
  nome: z
    .string()
    .trim()
    .min(2, { message: "Nome deve ter pelo menos 2 caracteres" })
    .max(100, { message: "Nome deve ter no máximo 100 caracteres" }),
  email: z
    .string()
    .trim()
    .email({ message: "Email inválido" })
    .max(255, { message: "Email deve ter no máximo 255 caracteres" }),
  telefone: z
    .string()
    .trim()
    .regex(brazilianPhoneRegex, { message: "Telefone inválido. Use o formato (XX) XXXXX-XXXX" })
    .max(20, { message: "Telefone deve ter no máximo 20 caracteres" }),
  empresa: z
    .string()
    .trim()
    .min(2, { message: "Empresa deve ter pelo menos 2 caracteres" })
    .max(100, { message: "Empresa deve ter no máximo 100 caracteres" }),
  mensagem: z
    .string()
    .trim()
    .min(10, { message: "Mensagem deve ter pelo menos 10 caracteres" })
    .max(2000, { message: "Mensagem deve ter no máximo 2000 caracteres" }),
});

export type ContactDialogFormData = z.infer<typeof contactDialogSchema>;
export type CadastroFormData = z.infer<typeof cadastroSchema>;
